<template>
  <div class="Swiper">
    <el-carousel trigger="click">
      <el-carousel-item v-for="(item, index) in ImgData" :key="index">
        <a :href="`${item.link}`" target="_blank">
          <img :src="item.url" alt />
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getBannerList } from "@/api/api.js";

export default {
  name: "pcHomeSwiper",
  data() {
    return {
      ImgData: []
    };
  },
  mounted() {
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      getBannerList().then(res => {
        if (res.code === 0) {
          this.ImgData = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
// .Swiper {
//   width: 100%;
//   height: 680px;
//   .el-carousel {
//     width: 100%;
//     height: 100%;
//   }
//   .el-carousel__container {
//     width: 100%;
//     height: 100%;
//   }
// }
@media (min-width: 1920px) {
  .Swiper {
    width: 100%;
    height: 680px;
    .el-carousel {
      width: 100%;
      height: 100%;
    }
    .el-carousel__container {
      width: 100%;
      height: 100%;
    }
  }
}
@media (min-width: 1200px) {
  .Swiper {
    width: 100%;
    height: 680px;
    .el-carousel {
      width: 100%;
      height: 100%;
    }
    .el-carousel__container {
      width: 100%;
      height: 100%;
    }
  }
}
@media (max-width: 1366px) {
  .Swiper {
    width: 100%;
    height: 476px;
    .el-carousel {
      width: 100%;
      height: 100%;
    }
    .el-carousel__container {
      width: 100%;
      height: 100%;
    }
  }
}

@media (max-width: 1200px) {
  .Swiper {
    width: 100%;
    height: 425px;
    .el-carousel {
      width: 100%;
      height: 100%;
    }
    .el-carousel__container {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
